import { ReactNode } from "react"
import cx from "classnames"

export interface TextPairProps {
  leftText: ReactNode
  rightText?: ReactNode
  className?: string
  leftClass?: string
  rightClass?: string
  testId?: string
}

const TextPair = ({
  leftText,
  rightText,
  className,
  leftClass,
  rightClass,
  testId,
}: TextPairProps) => (
  <p
    className={cx(
      "flex flex-col sm:flex-row justify-between gap-1 text-charcoal-500 text-base font-body leading-[140%] tracking-[0.32px]",
      className
    )}
    data-testid={testId ?? "text-pair"}
  >
    <span className={cx("text-dusk-700", leftClass)}>{leftText}</span>

    <span className={cx(rightClass)}>{rightText}</span>
  </p>
)

export default TextPair
